import { render, staticRenderFns } from "./DiagramCommentsBox.vue?vue&type=template&id=769863ca&scoped=true&"
import script from "./DiagramCommentsBox.vue?vue&type=script&lang=ts&"
export * from "./DiagramCommentsBox.vue?vue&type=script&lang=ts&"
import style0 from "./DiagramCommentsBox.vue?vue&type=style&index=0&id=769863ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769863ca",
  null
  
)

export default component.exports